import axios from "axios";

// VJ Rider screens (/rider, M15-F3). The Rider signs in with the Rider pool mobile + OTP and
// gets a Rider token (not a Sales App login), kept in this browser until it expires.
const base = () => `${process.env.REACT_APP_PAYMENT_LINK_URL}rider-app`;
const TOKEN_KEY = "vjRiderToken";
const data = (response) => response.data.data;

function riderToken() {
  try {
    const saved = JSON.parse(localStorage.getItem(TOKEN_KEY) || "null");
    return saved && saved.expiresAt > Date.now() ? saved : null;
  } catch {
    return null;
  }
}
function saveRiderToken(session) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(session));
}
function clearRiderToken() {
  localStorage.removeItem(TOKEN_KEY);
}
const auth = () => ({ headers: { Authorization: `Bearer ${riderToken()?.token || ""}` } });

// → { challengeId, digits, maskedMobile, expiresAt, resendAfterSeconds, resendsLeft }
async function askSignInOtp(mobile) {
  return data(await axios.post(`${base()}/auth/otp`, { mobile }));
}
// → { token, expiresAt, rider: { name, maskedMobile } }
async function verifySignInOtp(challengeId, otp) {
  return data(await axios.post(`${base()}/auth/verify`, { challengeId, otp }));
}
// → { counts: { today, upcoming, notDone }, registrations }
async function getRegistrations() {
  return data(await axios.get(`${base()}/registrations`, auth()));
}
async function getRegistration(slotBookingId) {
  return data(await axios.get(`${base()}/registrations/${slotBookingId}`, auth()));
}
// Mark Registration Done (M15-F4): registrationNo, registrationDate "YYYY-MM-DD", indexII / receipt files
// → { done, alreadyDone, registered }
async function markRegistrationDone(slotBookingId, { registrationNo, registrationDate, indexII, receipt }) {
  const form = new FormData();
  form.append("registrationNo", registrationNo);
  form.append("registrationDate", registrationDate);
  if (indexII) form.append("indexII", indexII);
  if (receipt) form.append("receipt", receipt);
  return data(await axios.post(`${base()}/registrations/${slotBookingId}/done`, form, auth()));
}

// { message, status, fields } from a failed request; status 401 = sign in again
function riderError(err) {
  return {
    status: err?.response?.status || 0,
    message: err?.response?.data?.error || (err?.response ? "Something went wrong" : "No internet connection. Please try again."),
    fields: err?.response?.data?.fields || {},
  };
}

export { riderToken, saveRiderToken, clearRiderToken, askSignInOtp, verifySignInOtp, getRegistrations, getRegistration, markRegistrationDone, riderError };
